const percent4 = {
    decimal: ",",
    thousands: ".",
    prefix: "% ",
    suffix: "",
    precision: 4,
    masked: false
}
  
export default percent4
